(function () {

  'use strict';

  function pxDriverConfig(PrintQueueListPaging, $ngBootbox, $filter, toastr, TenantListService, EventServiceEvents, SUPPORTED_OS) {
    return {
      restrict: 'EA',
      scope: {
        me: '=',
        isThisResourceMine: '=',
        printer: '=',
        printQueue: '=',
        printQueueOriginal: '=',
        workstationContainer: '='
      },
      templateUrl: 'app/components/printQueueProperties/driverConfig/driver-config.template.html',
      link: function (scope) {

        scope.showAllOS = false;
        scope.thresholdToSwitchCreatedTimeFormat = 6;
        scope.isAnywherePrintQueue = !isNaN(parseInt(scope.printQueue.info.signId));

        scope.tooltip = {
          RenameDriverConfigurationTooltip: 'RenameDriverConfigurationTooltip',
          EditDriverConfigurationTooltip: 'EditDriverConfigurationTooltip',
          DeleteDriverConfigurationTooltip: 'DeleteDriverConfigurationTooltip',
          CreateDriverConfigurationTooltip: 'CreateDriverConfigurationTooltip',
          NonGroupUsersSettingsTooltip: 'NonGroupUsersSettingsTooltip',
          GroupExclusiveAccessWarningTooltip: 'GroupExclusiveAccessWarningTooltip',
          PrintQueueUpdateOnComputersTooltip: 'PrintQueueUpdateOnComputersTooltip'
        };

        scope.remoteQueueManagementCalibrationObject = {
          originalModel: scope.printQueueOriginal,
          pagingObject: new PrintQueueListPaging(),
          requestType: 'POST',
          context: 'distributeQueueToQueues',
          setHelpCaptionRemoteQueueManagement: 'HelpPrintQueueuPropertiesRemoteQueueManagamentDistributeDriverConfig',
          resetHelpCaptionRemoteQueueManagement: 'HelpPrintQueuePropertiesDrivers',
          tooltip: 'DistributeQueueTooltip',
          searchInputPlaceholderText: 'SearchQueueByName'
        };

        scope.osDriverList = null;

        const driverConfigRenderOrderMap = [
          'WIN_11_ARM64',
          'WIN_11_64',
          'WIN_10_64',
          'WIN_10_32',
          'WIN_8_1_64',
          'WIN_8_1_32',
          'WIN_8_64',
          'WIN_8_32',
          'WIN_7_64',
          'WIN_7_32',
          'WIN_2016_64',
          'WIN_2012R2_64',
          'WIN_2012_64',
          'WIN_2008R2_64',
          'MAC_OS'
        ];

        (function () {
          setListeners();
          getDriverConfigs();
        })();

        function setListeners() {
          scope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_ADMINS.EVENTS.QUEUE_DRIVER_CONFIG_CHANGED, function (event, data) {
            getDriverConfigs();
          });
        }

        function getDriverConfigs() {
          scope.printQueue.getDriverConfigsKeyMap()
            .then(function (driverResources) {
              mapDriverConfigs(driverResources);
            })
            .catch(function () {
            });
        }

        function mapDriverConfigs(driverResources) {
          scope.osDriverList = [];
          driverConfigRenderOrderMap.forEach(systemKey => {
            const driverResource = driverResources.find(dr => dr.key === systemKey);
            if (driverResource) {
              scope.osDriverList.push({
                key: systemKey,
                value: getOperatingSystemName(systemKey),
                driverConfig: driverResource._embedded.driverConfiguration,
                driver: driverResource._embedded.lockedDriver,
                defaultDriver: driverResource._embedded.defaultDriver,
                show: scope.showAllOS || driverResource.workstationCount > 0,
                locked: driverResource.locked,
                wsCount: driverResource.workstationCount
              });
            }
          });
        }

        function getOperatingSystemName(systemKey) {
          if (systemKey === 'WIN_2016_64') {
            return 'Windows Server';
          }
          return SUPPORTED_OS.find(os => os.key === systemKey)?.value || systemKey;
        }

        scope.toggleAllSupportedOS = function () {
          scope.osDriverList.forEach(driver => {
            driver.show = scope.showAllOS || driver.wsCount > 0;
          });
        };

        scope.toggleLockPrintQueueDriver = function (os) {
          if (os.locked) {
            scope.printQueueOriginal.deleteDriver(os)
              .then(function () {
                toastr.success($filter('translate')('ChangesSaved'));
              })
              .catch(function () {
              });
          } else {
            scope.printQueueOriginal.addDriver(os.defaultDriver, os)
              .then(function () {
                toastr.success($filter('translate')('ChangesSaved'));
              })
              .catch(function () {
              });
          }
        };

        scope.deleteDriverConfigPopup = function (event, os) {
          event.stopPropagation();
          scope.clearPopups();

          scope.deleteDriverConfigConfiguration = {
            confirm: 'Yes',
            warning: null,
            danger: true,
            cancel: 'No',
            validationString: null,
            os
          };

          scope.deleteDriverPopupObject = {
            dimensions: { height: 85, width: 350 },
            offset: { top: 5, left: 45 },
            pointerDirection: null,
            pointerPosition: 'right',
            relativePosition: 'over',
            absoluteX: event.clientX,
            absoluteY: event.clientY,
            type: 'CONFIRM',
            title: 'DeleteDriverConfiguration',
            confirmText: null,
            clickOutsideToClose: true
          };
        };

        scope.deletePrinterDriverConfig = function (os) {
          scope.printQueueOriginal.deleteDriverConfiguration(os)
            .then(function () {
              toastr.success($filter('translate')('ChangesSaved'));
            })
            .catch(function () {
            });
        };

        scope.changeDriverConfigPopup = function (event, os, title) {
          event.stopPropagation();
          scope.clearPopups();

          scope.changeDriverConfigConfiguration = {
            os,
            name: os.driverConfig ? os.driverConfig.name : null,
            printer: scope.printer,
            printQueue: scope.printQueue,
            driver: os.defaultDriver,
            driverConfig: os.driverConfig
          };

          scope.changeDriverConfigPopupObject = {
            dimensions: { width: 525 },
            offset: { top: 5, left: 45 },
            pointerDirection: null,
            pointerPosition: 'right',
            relativePosition: 'over',
            absoluteX: event.clientX,
            absoluteY: event.clientY,
            type: 'CHANGE_DRIVER_CONFIG',
            title,
            confirmText: 'Confirm',
            clickOutsideToClose: true
          };

        };

        scope.addNewDriverConfig = function (event, os, title) {
          event.stopPropagation();
          scope.clearPopups();

          scope.addDriverConfigConfiguration = {
            os,
            name: os.driverConfig ? os.driverConfig.name : null,
            printer: scope.printer,
            printQueue: scope.printQueue,
            driver: os.defaultDriver,
            driverConfig: os.driverConfig
          };

          scope.addDriverConfigPopupObject = {
            dimensions: { width: 525 },
            offset: { top: 5, left: 45 },
            pointerDirection: null,
            pointerPosition: 'right',
            relativePosition: 'over',
            absoluteX: event.clientX,
            absoluteY: event.clientY,
            type: 'CHANGE_DRIVER_CONFIG',
            title,
            confirmText: 'Confirm',
            clickOutsideToClose: true
          };
        };

        scope.changeDriverConfig = function (item) {
          const name = item.driverConfigObject.name;
          const os = item.driverConfigObject.os;
          const workstation = item.driverConfigObject.workstation;
          const printer = scope.printer;
          const printQueue = scope.printQueue;
          const sourceConfiguration = item.driverConfigObject.id;
          const onlyUploadConfiguration = item.driverConfigObject.onlyUploadConfiguration;
          TenantListService.currentTenant.manageDriverConfig(name, os, workstation, printer, printQueue, sourceConfiguration, onlyUploadConfiguration)
            .then(function () {
              toastr.success($filter('translate')('ChangesSaved'));
            })
            .catch(function () {
            });
        };

        scope.renameDriverConfigPopup = function (event, os, driverConfig) {
          event.stopPropagation();
          scope.clearPopups();

          scope.renameDriverConfigConfiguration = {
            os,
            inputDataObject: [
              {
                label: 'Name',
                placeholder: 'Name',
                type: 'input',
                keyIdentifier: 'name',
                value: os.driverConfig.name,
                focus: true,
                allowEmptyInput: false,
                regex: null,
                driverConfig: os.driverConfig,
                printer: scope.printer
              }
            ]
          };

          scope.renameDriverConfigPopupObject = {
            dimensions: { height: 175, width: 400 },
            offset: { top: 5, left: 45 },
            pointerDirection: 'down',
            pointerPosition: 'right',
            relativePosition: 'over',
            absoluteX: event.clientX,
            absoluteY: event.clientY,
            context: 'addNewNetwork',
            type: 'SIMPLE_INPUT',
            title: 'ConfigurationName',
            confirmText: 'Save',
            clickOutsideToClose: true
          };
        };

        scope.renameDriverConfig = function (item, os) {
          TenantListService.currentTenant.updateDriverConfigName(item.value, os, item.driverConfig._links.self.href, scope.printer, scope.printQueue)
            .then(function (response) {
              toastr.success($filter('translate')('ChangesSaved'));
            })
            .catch(function () {
            });
        };

        scope.clearPopups = function () {
          scope.deleteDriverConfigConfiguration = null;
          scope.deleteDriverPopupObject = null;

          scope.changeDriverConfigConfiguration = null;
          scope.changeDriverConfigPopupObject = null;

          scope.addDriverConfigConfiguration = null;
          scope.addDriverConfigPopupObject = null;

          scope.renameDriverConfigConfiguration = null;
          scope.renameDriverConfigPopupObject = null;
        };

        scope.forceWorkstationsToGetLatestQueueUpdates = function () {
          $ngBootbox.confirm($filter('translate')('PrintQueueUpdateOnComputers'))
            .then(function () {
              const workstationModel = scope.workstationContainer.list[0];
              workstationModel.forceWorkstationsToGetLatestQueueUpdates(scope.printQueue, scope.printer)
                .then(function () {
                  toastr.success($filter('stringular')($filter('translate')('PrintQueueUpdatedOnComputers'), scope.printQueue.info.name));
                })
                .catch(function () {
                  toastr.error($filter('translate')('UpsSomethingWentWrong'));
                });
            })
            .catch(function () {
            });
        };

      }
    };
  }

  pxDriverConfig.$inject = [
    'PrintQueueListPaging', '$ngBootbox', '$filter', 'toastr', 'TenantListService', 'EventServiceEvents', 'SUPPORTED_OS'
  ];

  angular
    .module('printix-admin')
    .directive('pxDriverConfig', pxDriverConfig);

})();
